import { TeamAssociateStatus, TeamAssociateStatusType } from '@/api/types';
import type { BadgeColor } from '@/shared/design-system';

type TeamStatusConfig = {
  label: string;
  color: BadgeColor;
  tooltip: string;
};

export const TEAM_STATUS_CONFIG: Record<TeamAssociateStatusType, TeamStatusConfig> = {
  Verified: {
    label: TeamAssociateStatus.Verified,
    color: 'primary',
    tooltip: 'This user is a fully verified team member of your Entity.',
  },
  Pending: {
    label: TeamAssociateStatus.Pending,
    color: 'orange',
    tooltip:
      'This user has received an invitation email, but has not created their Gamma Prime profile yet.',
  },
  WaitingForApproval: {
    label: TeamAssociateStatus.WaitingForApproval,
    color: 'yellow',
    tooltip: `This user already has a Gamma Prime profile. Waiting for the user to approve their invitation to this Entity and complete their KYC, investor's questionnaire and profile.`,
  },
  SignedUp: {
    label: TeamAssociateStatus.SignedUp,
    color: 'secondary',
    tooltip: 'This user has registered but has not yet completed KYC or their profile.',
  },
  Rejected: {
    label: TeamAssociateStatus.Rejected,
    color: 'destructive',
    tooltip: 'This user has rejected an invitation to become a team member of your Entity.',
  },
  Blocked: {
    label: TeamAssociateStatus.Blocked,
    color: 'destructive',
    tooltip: 'This user is blocked.',
  },
};
